// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"cfbc6929","281":"6cd28ce0","387":"5246f68c","445":"6cab9066","474":"7d3d7be1","600":"9540286e","636":"cc647575","638":"1475539c","910":"05780115"}[chunkId] + ".chunk.css";
};